/**
 * @fileoverview BUD-03: the author's own list of Blossom servers.
 *
 * A page's index event names server hints, but an author who moves hosts would
 * otherwise have to republish every page. The BUD-03 list is the indirection
 * that makes moving a single edit: kind 10063, one `server` tag per host, in
 * the author's order of preference.
 *
 * It is fetched ONLY when the page's own hints have already failed. Most loads
 * never touch it, and a second relay round trip on the happy path would be paid
 * by every reader to help the few whose author has moved.
 */

import { fetchNewest } from '@/services/nostr/relays';
import { BLOSSOM_SERVER_LIST_KIND } from '@/services/pages/kinds';

export async function fetchAuthorServers(
  pubkey: string,
  relays: string[]
): Promise<string[]> {
  const event = await fetchNewest(relays, {
    kinds: [BLOSSOM_SERVER_LIST_KIND],
    authors: [pubkey],
  });
  if (!event) return [];

  return event.tags
    .filter((t) => t[0] === 'server' && typeof t[1] === 'string')
    .map((t) => t[1] as string)
    .filter((url) => {
      try {
        const u = new URL(url);
        return u.protocol === 'https:' || u.protocol === 'http:';
      } catch {
        return false;
      }
    });
}
